import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

Vue.use(ElementUI)

// 全局axios配置
axios.defaults.baseURL = '/api'
axios.interceptors.request.use(config => {
  NProgress.start()
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})
axios.interceptors.response.use(
  res => { NProgress.done(); return res },
  err => {
    NProgress.done()
    if (err.response && err.response.status === 401) {
      store.dispatch('logout')
      router.push('/login')
    }
    return Promise.reject(err)
  }
)
Vue.prototype.$http = axios

Vue.config.productionTip = false

// 移动端点击延迟修复
if ('ontouchstart' in window) {
  // 添加touch-action样式
  const style = document.createElement('style')
  style.textContent = `
    * {
      touch-action: manipulation;
      -ms-touch-action: manipulation;
    }
    button, a, [role="button"], .recent-item, .student-icon-item {
      touch-action: manipulation;
      -ms-touch-action: manipulation;
    }
  `
  document.head.appendChild(style)
  
  // 移除移动端长按菜单
  document.addEventListener('contextmenu', function(e) {
    if (e.target.tagName === 'BUTTON' || e.target.closest('button') || 
        e.target.closest('.recent-item') || e.target.closest('.student-icon-item')) {
      e.preventDefault()
    }
  }, false)
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
